import { Link, navigate } from '@reach/router';
import { AppPath, PUBLIC_SITE_URL } from 'appConstants';
import { HeaderDropdownMenu } from 'components/headerDropdownMenu/HeaderDropdownMenu';
import { PopoutMenu } from 'components/popupsAndPanels/PopoutMenu';
import { endpoints } from 'endpoints.config';
import { useFetchContentAndCache } from 'hooks/useFetchContentAndCache';
import { useOnClickOutside } from 'hooks/useOnClickOutside';
import ArrowDown from 'images/Icon_Dropdown_01.png';
import ArrowLeft from 'images/Icon_Pagination_Dropdown.png';
import HamburgerMenu from 'images/Icon_Menu.png';
import Logo from 'images/Logo.png';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectSignedIn, signOut } from 'reducers/auth';
import { selectUserInitials } from 'reducers/auth';
import { useGetDropdownLinks } from '../headerDropdownMenu/useGetDropdownLinks';
import { store } from '../../index';
import { loadTokenResource } from 'helpers/auth';
import { setUserInitials } from 'reducers/auth';

export interface HeaderItem {
  id: number;
  name: string;
  url: string;
  childElements?: HeaderItem[];
  bAbsoluteURL: boolean;
}

interface HeaderItemResponse {
  navigationLinks: HeaderItem[];
}

type HeaderProps = {
  menuItems?: HeaderItem;
};

const Header: React.FC<HeaderProps> = ({ menuItems }) => {
  const dispatch = useDispatch();
  const isSignedIn = useSelector(selectSignedIn);
  const userInitials = useSelector(selectUserInitials);

  const [burgerMenuIsOpen, setBurgerMenuIsOpen] = useState(false); 

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const linkListData: any = isSignedIn ? useGetDropdownLinks() : false;

  useEffect(() => {
    let initialsToUse: string = linkListData.profileInitials ? linkListData.profileInitials : window.localStorage.getItem('UI') ? window.localStorage.getItem('UI') : "GS";

    store.dispatch(setUserInitials(initialsToUse));
  }, [linkListData]);   

  const headerItems = useFetchContentAndCache<HeaderItemResponse>(
    endpoints.public.navigation.headerLinks,
    'headerLinks'
  );

  const handleBurgerMenuOpen = () => {
    setBurgerMenuIsOpen(true);
  };

  const handleBurgerMenuClose = () => {
    setBurgerMenuIsOpen(false);
  };

  const handleSignOut = () => {
    dispatch(signOut());
  };

  return (
    <header className="Header">
      {/* Main Header */}
      <div className="MainHeader WidthContent">
        <div className="HeaderLink">
          <a href={PUBLIC_SITE_URL} className="Logo">
            <img src={Logo} alt="GetSet4Education Logo" />
          </a>
        </div>
        <div className="HeaderActions">
          {headerItems &&
            headerItems.navigationLinks &&
            headerItems.navigationLinks.map((item, index) => {
              const hasChildElements =
                item.childElements && item.childElements.length > 0;
              return (
                <React.Fragment key={'HdrLink' + index}>
                  {hasChildElements ? (
                    <HeaderLinkWithChildElements item={item} />
                  ) : (
                    <div className="HeaderLink">
                      <a
                        href={`${PUBLIC_SITE_URL}${item.url}`}
                        rel="noreferrer"
                      >
                        {item.name}
                      </a>
                    </div>
                  )}
                </React.Fragment>
              );
            })}
          {isSignedIn ? (
            <HeaderDropdownMenu
              initials={userInitials}
              linkListData={linkListData.dropdownLinksInfo}
            />
          ) : (
            <>
              <Link
                to={AppPath.SUBSCRIBE}
                className="Btn BtnOrange SubscribeButton"
              >
                Subscribe
              </Link>
              {!isSignedIn && (
                <>
                  <Link
                    to={AppPath.SUBSCRIBE_FREE_TRIAL}
                    className="Btn BtnOrange FreeTrialButton"
                  >
                    Free trial
                  </Link>                
                  <Link
                    to={AppPath.SIGN_IN}
                    className="Btn BtnOrange SignInButton"
                  >
                    Sign in
                  </Link>
                </>
              )}
            </>
          )}
        </div>
      </div>

      {/*Mobile Header*/}
      <div className="MobileHeader">
        <div className="HamburgerMenuOpen" onClick={handleBurgerMenuOpen}>
          <img src={HamburgerMenu} alt="HamburgerMenu" />
        </div>
        <a href={isSignedIn ? '/' : PUBLIC_SITE_URL} className="Logo">
          <img src={Logo} alt="GetSet4Education Logo" />
        </a>
        <PopoutMenu
          isPopup={false}
          position="left"
          isOpen={burgerMenuIsOpen}
          handleClose={handleBurgerMenuClose}
          className="BurgerMenu"
          width={260}
          minWidth={260}
          mobileMenu={true}
        >
          <div className="BurgerMenuContent">
            {headerItems &&
              headerItems?.navigationLinks &&
              headerItems?.navigationLinks.map((item, index) => (
                <React.Fragment key={'MobHdrLink' + index}>
                  <div className="HeaderLink">
                    {item.childElements ? null : (
                      <a
                        href={`${PUBLIC_SITE_URL}${item.url}`}
                        aria-label={item.name}
                      >
                        {item.name}
                      </a>
                    )}
                  </div>

                  {item.childElements &&
                    item.childElements.map((childItem, index) => {
                      return (
                        <React.Fragment key={'MobHdrSubLink' + index}>
                          <div className="HeaderLink" key={childItem.id}>
                            {childItem.childElements ? null : (
                              <a
                                href={
                                  childItem.bAbsoluteURL
                                    ? `${childItem.url}`
                                    : `${PUBLIC_SITE_URL}${childItem.url}`
                                }
                                aria-label={childItem.name}
                              >
                                {`${
                                  item.name === 'About Us'
                                    ? ''
                                    : `${item.name} - `
                                }${childItem.name}`}
                              </a>
                            )}
                          </div>
                          {childItem.childElements &&
                            childItem.childElements.map((subChildItem, index) => (
                              <React.Fragment key={'MobHdrSubSubLink' + index}>
                                <div className="HeaderLink" key={subChildItem.id}>
                                  {subChildItem.childElements ? null : (
                                    <a
                                      href={
                                        subChildItem.bAbsoluteURL
                                          ? `${subChildItem.url}`
                                          : `${PUBLIC_SITE_URL}${subChildItem.url}`
                                      }
                                      aria-label={subChildItem.name}
                                    >
                                      {`${childItem.name} - ${subChildItem.name}`}
                                    </a>
                                  )}
                                </div>
                              </React.Fragment>
                            ))}
                        </React.Fragment>
                      );

})}
                </React.Fragment>
              ))}
            {linkListData && linkListData.dropdownLinksInfo &&
              linkListData.dropdownLinksInfo.map((item: any, index: number) => {
                if (item.displayName !== 'Sign out') {
                  return (
                    <React.Fragment key={'MobHdrLink' + index}>
                      <div className="HeaderLink" key={index}>
                        <a
                          href={
                            '/' +
                            item.displayName.toLowerCase().replaceAll(' ', '-')
                          }
                        >
                          {item.displayName}
                        </a>
                      </div>
                    </React.Fragment>
                  );
                }
              })}
            {isSignedIn ? (
              <button
                onClick={handleSignOut}
                className="Btn BtnOrange SignOutButton"
              >
                Sign out
              </button>
            ) : (
              <>
                <Link
                  to={AppPath.SUBSCRIBE}
                  className="Btn BtnOrange SubscribeButton"
                >
                  Subscribe
                </Link>
                <Link
                  to={AppPath.SUBSCRIBE_FREE_TRIAL}
                  className="Btn BtnOrange FreeTrialButton"
                >
                  Free trial
                </Link>
                <Link
                  to={AppPath.SIGN_IN}
                  className="Btn BtnOrange SignInButton"
                >
                  Sign in
                </Link>
              </>
            )}
          </div>
        </PopoutMenu>
      </div>
    </header>
  );
};

type HeaderLinkWithChildElementsProps = {
  item: HeaderItem;
};

export const HeaderLinkWithChildElements: React.FC<
  HeaderLinkWithChildElementsProps
> = ({ item }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleIsOpen = () => {
    setIsOpen((prevIsOpen) => !prevIsOpen);
  };

  const bind = useOnClickOutside(() => setIsOpen(false));

  return (
    <div className={`HeaderLink`} onClick={toggleIsOpen} {...bind}>
      <span>{item.name}</span>{' '}
      <img src={ArrowDown} alt="Open About us submenu" />
      {isOpen && (
        <div className="HeaderSubMenu" onMouseLeave={() => setIsOpen(false)}>
          {item.childElements?.map((item, index) => {
            const hasChildElements =
              item.childElements && item.childElements.length > 0;
            return hasChildElements ? (
              <HeaderSubLinkWithChildElements item={item} />
            ) : (
              <div key={'SubHdrLink' + index} className="HeaderSubLink">
                <a
                  target="_self"
                  href={
                    item.bAbsoluteURL
                      ? `${item.url}`
                      : `${PUBLIC_SITE_URL}${item.url}`
                  }
                  rel="noreferrer"
                >
                  {item.name}
                </a>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export const HeaderSubLinkWithChildElements: React.FC<
  HeaderLinkWithChildElementsProps
> = ({ item }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleIsOpen = () => {
    setIsOpen((prevIsOpen) => !prevIsOpen);
  };

  const bind = useOnClickOutside(() => setIsOpen(false));

  return (
    <div
      className={`HeaderSubLink SubMenu`}
      onClick={toggleIsOpen}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
      {...bind}
    >
      <span>{item.name}</span>
      <img src={ArrowLeft} alt="Open About us submenu" />
      {isOpen && (
        <div className="HeaderSubSubLink">
          {item.childElements?.map((item) => (
            <div className="HeaderSubLink" key={item.id}>
              <a
                href={
                  item.bAbsoluteURL
                    ? `${item.url}`
                    : `${PUBLIC_SITE_URL}${item.url}`
                }
                aria-label={item.name}
                rel="noreferrer"
              >
                {item.name}
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Header;
